// import React from "react";
// import styled from "styled-components";
// import { COLORS } from "../../../Constants/colors";
// import aiml from "../../../Assets/aiml.png"; // Replace with actual image
// import SectionWrapper from "../UI/SectionWrapper";

// const Section = styled.section`
//   display: flex;
//   width: 100%;
//   height: auto;
//   overflow: hidden;
//   background-color: ${COLORS?.backgroundLight};
//   border-radius: 16px;

//   @media (max-width: 1250px) {
//     flex-direction: column-reverse;
//   }
// `;

// const Content = styled.div`
//   flex: 5;
//   padding: 3rem;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   background-color: ${COLORS.cardBackground};
//   color: ${COLORS?.textPrimary};

//   @media (max-width: 768px) {
//     padding: 2rem 1.5rem;
//   }
// `;

// const Image = styled.div`
//   flex: 5;
//   position: relative;
//   overflow: hidden;
//   border-radius: 0 16px 16px 0;

//   img {
//     width: 100%;
//     height: 100%;
//     object-fit: cover;
//     display: block;
//   }

//   @media (max-width: 1024px) {
//     border-radius: 16px 16px 0 0;
//   }
// `;

// const FeatureList = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 1.4rem;
//   margin-top: 1.5rem;
// `;

// const FeatureItem = styled.div`
//   display: flex;
//   align-items: flex-start;
//   gap: 0.8rem;
// `;

// const Icon = styled.div`
//   font-size: 1.3rem;
//   color: ${COLORS?.primary};
// `;

// const TextContent = styled.div`
//   h4 {
//     margin: 0;
//     font-size: 1.2rem;
//     color: ${COLORS?.primary};
//   }

//   p {
//     margin: 0.3rem 0 0;
//     font-size: 1.1rem;
//     line-height: 1.6;
//     color: ${COLORS?.textPrimary};
//   }
// `;

// const ViewMoreButton = styled.button`
//   margin-top: 2rem;
//   align-self: flex-start;
//   padding: 0.6rem 1.4rem;
//   background-color: ${COLORS?.primary};
//   color: ${COLORS?.buttonText};
//   font-size: 1rem;
//   border-radius: 8px;
//   border: none;
//   cursor: pointer;
//   transition: background-color 0.2s ease;

//   &:hover {
//     background-color: ${COLORS?.secondary};
//   }
// `;

// const AIMLComponent = ({
//     heading,
//     intro,
//     features,
//     image,
//     onViewMore
//   }) => {
//     return (
//       <SectionWrapper heading={heading}>
//         <Section>
//           <Content>
//             {intro && <p>{intro}</p>}
  
//             <FeatureList>
//               {features?.map((feature, index) => (
//                 <FeatureItem key={index}>
//                   <Icon>{feature.icon}</Icon>
//                   <TextContent>
//                     <h4>{feature.title}</h4>
//                     <p>{feature.description}</p>
//                   </TextContent>
//                 </FeatureItem>
//               ))}
//             </FeatureList>
  
//             {onViewMore && (
//               <ViewMoreButton onClick={onViewMore}>
//                 View More
//               </ViewMoreButton>
//             )}
//           </Content>
//           <Image>
//             <img src={image} alt={heading} />
//           </Image>
//         </Section>
//       </SectionWrapper>
//     );
//   };


// const AIMLConfig = {
//     heading: "ARTIFICIAL INTELLIGENCE & MACHINE LEARNING",
//     intro:
//       "Virtuosoft Technologies deliver end-to-end AI solutions spanning predictive analytics, NLP, computer vision, speech AI, deep reinforcement learning, and generative models.",
//     image: aiml,
//     features: [
//       {
//         icon: "📊",
//         title: "Predictive Analytics & Decision Automation",
//         description: "ML models for forecasting, process optimisation."
//       },
//       {
//         icon: "💬",
//         title: "Natural Language Processing (NLP)",
//         description: "Chatbots, document summarisation, semantic search, generative AI."
//       },
//       {
//         icon: "🖼️",
//         title: "Computer Vision & Image Analytics",
//         description: "Object detection, image classification, segmentation, video analytics."
//       },
//       {
//         icon: "🧠",
//         title: "LLM Fine-Tuning, RAG, Local LLM Inference",
//         description:
//           "Custom models for domain-specific tasks, retrieval-augmented generation, local deployment for privacy and performance."
//       },
//       {
//         icon: "🎙️",
//         title: "Speech & Audio AI",
//         description: "Speech recognition, audio classification, voice assistants."
//       },
//       {
//         icon: "🤖",
//         title: "Deep Reinforcement Learning",
//         description: "AI agents for autonomous decision-making."
//       },
//       {
//         icon: "🎨",
//         title: "Generative & Representation Learning",
//         description: "GANs, self-supervised learning, deep generative models."
//       }
//     ]
//   };
  
// function AIMLSection() {
//     return (
//       <AIMLComponent
//         heading={AIMLConfig.heading}
//         intro={AIMLConfig.intro}
//         features={AIMLConfig.features}
//         image={AIMLConfig.image}
//         onViewMore={() => console.log("View More Clicked")}
//       />
//     );
// }
  

// export default AIMLSection;


import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import aiml from "../../../Assets/aiml.png";
import SectionWrapper from "../UI/SectionWrapper";
import { COLORS } from "../../../Constants/colors";


const Section = styled.section`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  background: ${COLORS.background};
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

const Content = styled.div`
  flex: 1.5;
  padding: 1rem 2rem;
  background: linear-gradient(
        135deg,
        rgba(99, 102, 241, 0.1),
        rgba(236, 72, 153, 0.1)
    );
  color: ${COLORS.textPrimary};
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
  }

  @media (max-width: 480px) {
    padding: 1.5rem 1rem;
  }
`;

const Image = styled.div`
  flex: 1;
  position: relative;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  @media (max-width: 1024px) {
    border-radius: 16px 16px 0 0;
  }
`;

const Intro = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
  margin-bottom: 1rem;
  color: ${COLORS.textSecondary};

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const FeatureList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 0.6rem;

  @media (max-width: 480px) {
    gap: 1rem;
  }
`;

const FeatureItem = styled.div`
  background: linear-gradient(
        135deg,
        rgba(99, 102, 241, 0.1),
        rgba(236, 72, 153, 0.1)
    );
  padding: 1rem;
  border-radius: 12px;
  transition: transform 0.2s ease;
  display: flex;
  gap: 1rem;
  align-items: flex-start;

  &:hover {
    transform: translateY(-4px);
  }
`;

const Icon = styled.div`
  font-size: 1.5rem;
  color: ${COLORS.primary};
`;

const TextContent = styled.div`
  h4 {
    margin: 0;
    font-size: 1rem;
    color: ${COLORS.primary};
  }

  p {
    margin-top: 0.3rem;
    font-size: 1.1rem;
    color: ${COLORS.textPrimary};
  }

  @media (max-width: 480px) {
    h4 {
      font-size: 1rem;
    }

    p {
      font-size: 0.95rem;
    }
  }
`;


const ButtonWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: flex-start;

  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

const ExpandButton = styled.button`
  display: inline-block;
  padding: 10px 16px;
  border: 2px solid ${COLORS.primary};
  color: ${COLORS.primary};
  background: transparent;
  border-radius: 50px;
  font-weight: 600;
  text-decoration: none;
  cursor:pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background: ${COLORS.primary};
    color: ${COLORS.buttonText};
    transform: translateY(-2px);
  }
`;

const AIMLComponent = ({ heading, intro, features, image, onViewMore }) => {  
  return (
    <SectionWrapper heading={heading}>
      <Section>
        <Image>
            <img src={image} alt={heading} />
        </Image>
        <Content>
          <Intro>{intro}</Intro>
          <FeatureList>
            {features?.map((feature, index) => (
              <FeatureItem key={index}>
                <Icon>{feature.icon}</Icon>
                <TextContent>
                  <h4>{feature.title}</h4>
                </TextContent>
              </FeatureItem>
            ))}
          </FeatureList>
          {onViewMore && (
            <ButtonWrapper>
                <ExpandButton onClick={onViewMore}>
                    Read More →
                </ExpandButton>
            </ButtonWrapper>
          )}
        </Content>
      </Section>
    </SectionWrapper>
  );
};

const AIMLConfig = {
  heading: "ARTIFICIAL INTELLIGENCE & MACHINE LEARNING",
  intro:
      "Artificial Intelligence (AI) and Machine Learning (ML) empower businesses to unlock insights, automate decisions, and create intelligent experiences that adapt and improve over time. By combining data-driven algorithms with human ingenuity, Virtuosoft Technologies deliver innovative solutions that transform possibilities into measurable impact.",
  image: aiml,
  features: [
      {
      icon: "📈", // Better for analytics and forecasting
      title: "Predictive Analytics & Decision Automation",
      description: "ML models for forecasting, process optimisation.",
      },
      {
      icon: "🗣️", // Represents speech and language
      title: "Natural Language Processing (NLP)",
      description:
          "Chatbots, document summarisation, semantic search, generative AI.",
      },
      {
      icon: "🔍", // Symbolizes vision and detection
      title: "Computer Vision & Image Analytics",
      description:
          "Object detection, image classification, segmentation, video analytics.",
      },
      {
      icon: "🧠", // Perfect for LLMs and intelligence
      title: "LLM Fine-Tuning, RAG, Local LLM Inference",
      description:
          "Custom models for domain-specific tasks, retrieval-augmented generation, local deployment for privacy and performance.",
      },
      {
      icon: "🎧", // More intuitive for audio
      title: "Speech & Audio AI",
      description:
          "Speech recognition, audio classification, voice assistants.",
      },
      {
      icon: "🕹️", // Represents control and decision-making
      title: "Deep Reinforcement Learning",
      description: "AI agents for autonomous decision-making.",
      },
      {
      icon: "🧬", // Symbolizes generative and learning models
      title: "Generative & Representation Learning",
      description: "GANs, self-supervised learning, deep generative models.",
      },
  ],
};


function AIMLSection() {
  const navigate = useNavigate();

  return (
    <AIMLComponent
      heading={AIMLConfig.heading}
      intro={AIMLConfig.intro}
      features={AIMLConfig.features}
      image={AIMLConfig.image}
      onViewMore={() => navigate("/ai")}
    />
  );
}

export default AIMLSection;
